import * as Yup from 'yup'

const phonePattern = '\\+? *1?[- ()]*\\d{3}[- ()]*\\d{3}[- ()]*\\d{4}'
const phoneRegExp = new RegExp(phonePattern)

export const getFieldValidationSchema = ({ inputType, validations }) => {
  // The Eloqua team has been instructed to only ever use the 'required' rule on fields, so we can assume that if any rules are present that the field is simply required.
  const required = validations && validations.length
  switch (inputType) {
    case 'tel':
      return required
        ? Yup.string()
            .matches(phoneRegExp, 'Enter a valid phone number')
            .required('Required')
        : Yup.string().matches(phoneRegExp, 'Enter a valid phone number')
    case 'email':
      return required
        ? Yup.string()
            .email('Enter a valid email')
            .required('Required')
        : Yup.string().email('Enter a valid email')
    default:
      return required ? Yup.string().required('Required') : Yup.string()
  }
}

// @TODO remove displayType once the Emily starts sending 'submit' as the inputType.
export const getFieldProps = (
  inputType,
  label,
  labelType,
  displayType,
  options = []
) => {
  let result = { type: inputType, htmlElement: 'input' }
  if (['singleSelect', 'multiSelect'].includes(inputType)) {
    result = { type: inputType, htmlElement: 'singleSelect', options }
  } else if (inputType === 'textArea') {
    result = { htmlElement: 'textarea', as: 'textarea' }
  } else if (inputType === 'submit' || displayType === 'submit') {
    result = { type: 'submit', label }
  } else if (inputType === 'tel') {
    result.pattern = phonePattern
  }
  // If this form is set to use placeholders instead of labels, set a placeholder.
  if (labelType === 'placeholder') {
    result.placeholder = label
  }
  return result
}
